import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { actions } from './actions';
import { PKState } from './state';
import * as getters from './getters';
import mutations from './mutations';
import modules from './modules/index';

Vue.use(Vuex);

export const state: PKState = {
  monthSlideset: null,
  allNews: [],
  frontText: [],
  archiveEditions: [],
  criticalEditions: [],
  searchResult: [],
  currentSlideset: null,
  documents: [],
  timelineData: null,
  timelineNavEvent: null,
  timelineToolBar: [
    {
      src: "timeline/icons-ausblenden.svg",
      enable: true,
      name: "ausblenden",
      tooltip: "hide symbols",
    },
    {
      src: "timeline/icons-einblenden.svg",
      enable: false,
      name: "einblenden",
      tooltip: "show icons",
    },
    {
      src: "timeline/konfiguration-laden.svg",
      enable: true,
      name: "laden",
      tooltip: "load configuration",
    },
    {
      src: "timeline/konfiguration-speichern.svg",
      enable: true,
      name: "speichern",
      tooltip: "save configuration",
    },
    {
      src: "timeline/hilfe.svg",
      enable: true,
      name: "hilfe",
      tooltip: "help",
    },
  ],
};

const store: StoreOptions<PKState> = {
  state,
  getters,
  actions,
  mutations,
  modules
};

export default new Vuex.Store<PKState>(store);
